<script setup lang="ts">
const { t } = useI18n()
const globalStore = useGlobalStore()

const siteURL = computed(
  () =>
    `${globalStore.siteURL}?utm_source=rdi&utm_medium=banner_header&utm_campaign=createyourcatalog`,
)

const { event } = useEvent()
</script>
<template>
  <a
    class="ad-banner block"
    :href="siteURL"
    target="_blank"
    @click="event('product_catalog_freebanner')"
  >
    <div class="m-auto flex w-full items-stretch justify-between gap-2 xl:w-[1280px]">
      <div class="py-2 pl-4 sm:py-6 sm:pl-10">
        <h2 class="mb-3 text-sm text-[#3A4E4D] sm:mb-4 sm:text-3xl">
          <i18n-t keypath="components.header.adBanner.title" scope="global">
            <template #boldTitle>
              <b>
                {{ t('components.header.adBanner.boldTitle') }}
              </b>
            </template>
          </i18n-t>
        </h2>
        <a
          class="flex min-h-[18px] w-fit items-center justify-center rounded-[4px] bg-[#19A944] px-3 text-[8px] font-semibold text-white sm:min-h-[32px] sm:rounded-md sm:text-base"
        >
          {{ t('components.header.adBanner.action') }}
        </a>
      </div>
      <div
        class="ad-banner-person flex w-[432px] flex-col items-end justify-between py-2 pr-4 sm:py-6 sm:pr-10"
      >
        <span
          class="flex h-5 min-w-[26px] items-center justify-center rounded bg-[#C31162] px-1 text-[8px] font-semibold uppercase text-white"
        >
          {{ t('components.header.adBanner.info') }}
        </span>
        <img src="/images/rediredi-logo.png" alt="RediRedi" class="w-16 sm:w-[124px]" />
      </div>
    </div>
  </a>
</template>
<style scoped>
.ad-banner {
  background: linear-gradient(0deg, #ffffff, #ffffff), linear-gradient(0deg, #f5f5f5, #f5f5f5);
  background-image: url('/images/ad-banner-background.png');
  background-size: cover;
}
.ad-banner-person {
  background-image: url('/images/ad-banner-person.png');
  background-size: cover;
}
</style>
